import { createStreamEpic } from '../../../signalr/createStreamEpic'
import { fetchQueueStatsDefinition } from './definition'

export default createStreamEpic('queueStats.fetch', fetchQueueStatsDefinition)
